import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PriceListArea } from '../models/pricelist-area.model';
import { PriceListService } from '../services/pricelist.service';
import { SharedDataStore } from '../store';
import { LoadingService } from '@lx/shared/ui/loading-spinner';
import { Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import { withPriceListResolver } from './price-lists-resolver.mixin';
import { PriceListRoutes } from '../models/pricelist.routes';

@Injectable({ providedIn: 'root' })
export class PriceListsDynamicYearResolverService {
  private readonly priceListService = inject(PriceListService);
  private readonly sharedDataStore = inject(SharedDataStore);
  private readonly loadingService = inject(LoadingService);
  private readonly router = inject(Router);

  private readonly mixin = withPriceListResolver({
    priceListService: this.priceListService,
    sharedDataStore: this.sharedDataStore,
    loadingService: this.loadingService,
    router: this.router,
  });

  resolve(priceListArea: PriceListArea, route: ActivatedRouteSnapshot) {
    const selectedYear = route.paramMap.get('year');
    if (!selectedYear) {
      this.router.navigate([PriceListRoutes.NOT_FOUND]).then();
      return of(undefined);
    }

    this.sharedDataStore.updateState({
      priceListArea,
      currentPriceListYear: selectedYear,
    });

    const yearAndAccess$ = this.sharedDataStore.privateAccess$.pipe(switchMap((privateAccess) => of({ year: selectedYear, privateAccess })));

    return this.mixin.resolvePriceLists$(priceListArea, yearAndAccess$);
  }
}
